/* subject-redesign.js — 教科別一覧のスクロール進捗バー
   横スクロール量に応じて .sbj2-progress-fill の幅と位置を更新する。
   はみ出しが無い場合はバーごと非表示。JS無効時はバーが飾りとして残るだけで実害なし。 */
(function () {
  'use strict';

  function init() {
    var scrollers = document.querySelectorAll('[data-sbj2-scroller]');
    if (!scrollers.length) return;

    scrollers.forEach(function (sc) {
      var block = sc.closest('.sbj2-block');
      if (!block) return;
      var bar = block.querySelector('.sbj2-progress');
      var fill = block.querySelector('.sbj2-progress-fill');
      if (!bar || !fill) return;

      function update() {
        var max = sc.scrollWidth - sc.clientWidth;
        if (max <= 1) {
          bar.style.display = 'none';
          return;
        }
        bar.style.display = '';
        var frac = sc.clientWidth / sc.scrollWidth; // 見えている割合
        var pos = sc.scrollLeft / max;              // スクロール位置 0〜1
        var widthPct = frac * 100;
        fill.style.width = widthPct + '%';
        fill.style.left = (pos * (100 - widthPct)) + '%';
      }

      sc.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
